// extracted by mini-css-extract-plugin
export default {"container":"Header_container__8-WU1","heading":"Header_heading__oa6-W","right":"Header_right__2M-Is"};